export const pickLang = (value, lang) => {
  if (value && typeof value === "object" && ("vi" in value || "en" in value)) {
    return value[lang] || value.vi;
  }
  return value;
};

const guideCopy = {
  toc: {
    register: { vi: "Đăng ký tài khoản và mua gói", en: "Register an account and buy a plan" },
    createContract: { vi: "Lập hợp đồng", en: "Create a contract" },
    basicContract: { vi: "Lập hợp đồng cơ bản", en: "Basic contract setup" },
    newDocument: { vi: "Tạo tài liệu mới", en: "Create a new document" },
    draftDocument: { vi: "Soạn thảo tài liệu", en: "Draft the document" },
    trackDocument: { vi: "Hoàn tất và theo dõi tài liệu", en: "Complete and track the document" },
  },
  register: {
    label: { vi: "ĐĂNG KÝ", en: "REGISTER" },
    title: { vi: "Đăng ký tài khoản và mua gói", en: "Register an account and buy a plan" },
    lead: {
      vi: "Người dùng mới tạo tài khoản, chia sẻ thông tin qua VNeID, chọn gói và hoàn tất thanh toán trước khi sử dụng dịch vụ.",
      en: "New users create an account, share information via VNeID, choose a plan and complete payment before using the service.",
    },
    videoLabel: {
      vi: "Video hướng dẫn đăng ký tài khoản và mua gói",
      en: "Video guide: register an account and buy a plan",
    },
    steps: [
      {
        label: { vi: "Bước 1", en: "Step 1" },
        title: { vi: "Đăng ký tài khoản", en: "Register an account" },
        items: {
          vi: [
            "Người dùng mới đăng ký tài khoản GoPaperless.",
            "Đăng nhập vào hệ thống.",
          ],
          en: [
            "New users register a GoPaperless account.",
            "Sign in to the system.",
          ],
        },
        images: [
          {
            file: "dang-nhap.png",
            alt: { vi: "Màn hình đăng nhập GoPaperless", en: "GoPaperless sign-in screen" },
          },
          {
            file: "bam-dang-ky.png",
            alt: { vi: "Bấm đăng ký tài khoản", en: "Click to register an account" },
          },
          {
            file: "dien-thong-tin-dang-ky.png",
            alt: { vi: "Điền thông tin đăng ký tài khoản", en: "Fill in registration details" },
          },
        ],
      },
      {
        label: { vi: "Bước 2", en: "Step 2" },
        title: { vi: "Chia sẻ thông tin qua VNeID", en: "Share information via VNeID" },
        items: {
          vi: [
            "Người dùng thực hiện chia sẻ thông tin cá nhân/doanh nghiệp thông qua VNeID.",
            "Hệ thống tiếp nhận và cập nhật thông tin.",
          ],
          en: [
            "The user shares personal or business information through VNeID.",
            "The system receives and updates the information.",
          ],
        },
        images: [
          {
            file: "chia-se-thong-tin.png",
            alt: { vi: "Chia sẻ thông tin qua VNeID", en: "Share information via VNeID" },
          },
        ],
      },
      {
        label: { vi: "Bước 3", en: "Step 3" },
        title: { vi: "Mua gói / nạp tiền", en: "Buy a plan / top up" },
        items: {
          vi: [
            "Người dùng chọn **gói dịch vụ** muốn sử dụng.",
            "Nhập **mã giới thiệu** nếu có.",
            "Kiểm tra lại thông tin đăng ký và gói dịch vụ.",
            "Đồng ý với **biểu phí dịch vụ phát sinh** và **bảng giá bậc thang tạo mới hồ sơ**.",
            "Nhấn **Tạo thanh toán**.",
          ],
          en: [
            "The user chooses the **service package** they want to use.",
            "Enter a **referral code** if available.",
            "Review the registration details and selected plan.",
            "Agree to the **additional service fee schedule** and the **tiered pricing for creating new records**.",
            "Click **Create payment**.",
          ],
        },
        images: [
          {
            file: "mua-goi.png",
            alt: { vi: "Màn hình mua gói / nạp tiền", en: "Buy a plan / top-up screen" },
          },
        ],
      },
      {
        label: { vi: "Bước 4", en: "Step 4" },
        title: { vi: "Thanh toán", en: "Payment" },
        items: {
          vi: [
            "Hệ thống hiển thị **mã QR thanh toán**.",
            "Người dùng sử dụng ứng dụng ngân hàng để quét mã QR và thực hiện thanh toán.",
          ],
          en: [
            "The system displays the **payment QR code**.",
            "The user scans the QR code with a banking app and completes payment.",
          ],
        },
        images: [
          {
            file: "thanh-toan.png",
            alt: { vi: "Màn hình thanh toán bằng mã QR", en: "QR payment screen" },
          },
        ],
      },
      {
        label: { vi: "Bước 5", en: "Step 5" },
        title: { vi: "Xác nhận thanh toán", en: "Payment confirmation" },
        items: {
          vi: [
            "Hệ thống tự động kiểm tra trạng thái thanh toán.",
            "Khi thanh toán thành công, hiển thị: Nạp tiền thành công.",
          ],
          en: [
            "The system automatically checks the payment status.",
            "When payment succeeds, the screen shows: Top-up successful.",
          ],
        },
        images: [
          {
            file: "xac-nhan-thanh-toan.png",
            alt: { vi: "Màn hình xác nhận nạp tiền thành công", en: "Top-up success confirmation screen" },
          },
        ],
      },
      {
        label: { vi: "Bước 6", en: "Step 6" },
        title: { vi: "Hoàn tất", en: "Complete" },
        items: {
          vi: [
            "Người dùng nhấn **Hoàn tất**.",
            {
              text: "Hệ thống chuyển đến màn hình **Số dư & Lịch sử giao dịch** để người dùng kiểm tra:",
              children: ["Số tiền hiện có", "Lịch sử nạp tiền", "Lịch sử giao dịch"],
            },
          ],
          en: [
            "The user clicks **Complete**.",
            {
              text: "The system opens **Balance & transaction history** so the user can check:",
              children: ["Available balance", "Top-up history", "Transaction history"],
            },
          ],
        },
        images: [
          {
            file: "hoan-tat-kiem-tra.png",
            alt: {
              vi: "Màn hình Số dư & Lịch sử giao dịch sau khi hoàn tất",
              en: "Balance & transaction history screen after completion",
            },
          },
        ],
      },
    ],
  },
  contract: {
    label: { vi: "HỢP ĐỒNG", en: "CONTRACT" },
    title: { vi: "Lập hợp đồng", en: "Create a contract" },
    videoLabel: { vi: "Video hướng dẫn lập hợp đồng", en: "Video guide: create a contract" },
    basicTitle: { vi: "Lập hợp đồng cơ bản", en: "Basic contract setup" },
    newDocTitle: { vi: "Tạo tài liệu mới", en: "Create a new document" },
    draftTitle: { vi: "Soạn thảo tài liệu", en: "Draft the document" },
    trackTitle: { vi: "Hoàn tất và theo dõi tài liệu", en: "Complete and track the document" },
    trackLead: {
      vi: "Sau khi phát hành tài liệu, người tạo có thể chủ động theo dõi tiến độ xử lý và trạng thái ký thông qua 2 cách sau:",
      en: "After publishing the document, the creator can track processing progress and signing status in two ways:",
    },
    trackMethods: [
      {
        label: { vi: "Cách 1", en: "Method 1" },
        body: {
          vi: "Theo dõi tổng quan hồ sơ tại trang **Tài liệu**.",
          en: "Track an overview of the file on the **Documents** page.",
        },
        file: "theo-doi-tong-quan.png",
        alt: {
          vi: "Theo dõi tổng quan hồ sơ tại trang Tài liệu",
          en: "Track file overview on the Documents page",
        },
        caption: {
          vi: "Placeholder — theo-doi-tong-quan.png",
          en: "Placeholder — theo-doi-tong-quan.png",
        },
      },
      {
        label: { vi: "Cách 2", en: "Method 2" },
        body: {
          vi: "Theo dõi chi tiết qua **Nhật ký kiểm tra**, chọn trực tiếp vào tên tài liệu cần kiểm tra để vào màn hình chi tiết. Di chuyển xuống mục **Hành động** và chọn thẻ **Nhật ký kiểm tra** (hoặc nút **Nhật ký kiểm tra** ở góc trên) để xem mốc thời gian chi tiết từng hành động (Đã xem bởi ai, vào thời gian nào, đã ký lúc nào).",
          en: "Track details in **Audit log**: open the document name to view the detail screen. Scroll to **Actions** and select the **Audit log** tab (or the **Audit log** button at the top) to see timestamps for each action (who viewed it, when, and when it was signed).",
        },
        file: "theo-doi-nhat-ky.png",
        alt: {
          vi: "Nhật ký kiểm tra — mốc thời gian từng hành động",
          en: "Audit log — timestamps for each action",
        },
        caption: {
          vi: "Placeholder — theo-doi-nhat-ky.png",
          en: "Placeholder — theo-doi-nhat-ky.png",
        },
      },
    ],
    createSteps: [
      {
        label: { vi: "Bước 1", en: "Step 1" },
        body: {
          vi: "Tại thanh menu, chọn mục **Tài liệu**.",
          en: "On the menu bar, select **Documents**.",
        },
        file: "tao-tai-lieu-menu.png",
        alt: {
          vi: "Menu Tài liệu trên thanh điều hướng GoPaperless",
          en: "Documents menu on the GoPaperless navigation bar",
        },
        caption: {
          vi: "Ảnh bước 1 — menu Tài liệu (bổ sung sau)",
          en: "Step 1 image — Documents menu (to be added)",
        },
      },
      {
        label: { vi: "Bước 2", en: "Step 2" },
        body: {
          vi: "Nhấn nút **Bắt đầu** để mở giao diện khởi tạo tài liệu mới.",
          en: "Click **Start** to open the new document setup screen.",
        },
        alt: { vi: "Nút Bắt đầu để lập hợp đồng", en: "Start button to create a contract" },
        file: "tao-tai-lieu-bat-dau.png",
        caption: {
          vi: "Ảnh bước 2 — nút Bắt đầu (bổ sung sau)",
          en: "Step 2 image — Start button (to be added)",
        },
      },
      {
        label: { vi: "Bước 3", en: "Step 3" },
        body: {
          vi: "Tại mục **Tải lên tài liệu**, có 2 cách để thực hiện tải tệp tài liệu cần ký:",
          en: "Under **Upload document**, there are two ways to upload the file to sign:",
        },
        items: {
          vi: [
            "**Cách 1:** Kéo thả tệp tài liệu vào ô tải tài liệu.",
            "**Cách 2:** Chọn vào ô tải tài liệu và chọn tệp tài liệu cần ký.",
          ],
          en: [
            "**Method 1:** Drag and drop the file into the upload box.",
            "**Method 2:** Click the upload box and choose the file to sign.",
          ],
        },
        alt: {
          vi: "Khu vực tải lên tài liệu — kéo thả hoặc chọn tệp",
          en: "Document upload area — drag and drop or choose a file",
        },
        file: "tao-tai-lieu-tai-len.png",
        caption: {
          vi: "Ảnh bước 3 — ô tải tài liệu (bổ sung sau)",
          en: "Step 3 image — upload box (to be added)",
        },
      },
      {
        label: { vi: "Bước 4", en: "Step 4" },
        body: {
          vi: "Tùy theo nhu cầu với quy trình ký, chọn 1 trong 4 hình thức sau:",
          en: "Depending on your needs, choose one of the four workflows:",
        },
        modes: [
          {
            num: "01",
            title: { vi: "Tuần tự", en: "Sequential" },
            body: {
              vi: "Tài liệu được chuyển lần lượt theo thứ tự người nhận (người sau chỉ nhận được thông báo khi người trước đã hoàn tất xử lý).",
              en: "The document is sent in recipient order (the next person is notified only after the previous person has finished).",
            },
          },
          {
            num: "02",
            title: { vi: "Song song", en: "Parallel" },
            body: {
              vi: "Tất cả người nhận nhận tài liệu cùng lúc và có thể xử lý độc lập mà không cần chờ nhau.",
              en: "All recipients receive the document at the same time and work independently, without waiting for each other.",
            },
          },
          {
            num: "03",
            title: { vi: "Cá nhân", en: "Individual" },
            body: {
              vi: "Hệ thống tạo riêng từng bản sao cho mỗi người nhận, tiến trình xử lý của từng người hoàn toàn tách biệt.",
              en: "The system creates a separate copy for each recipient, each person's progress is independent.",
            },
          },
          {
            num: "04",
            title: { vi: "Tùy chỉnh", en: "Custom" },
            body: {
              vi: "Kết hợp giữa tuần tự và song song (chia theo từng nhóm thứ tự; những người cùng một bậc/thứ tự sẽ xử lý song song trước khi chuyển sang bậc tiếp theo).",
              en: "Combines sequential and parallel (divided into ordered groups; individuals at the same tier or sequence process tasks in parallel before advancing to the next tier).",
            },
          },
        ],
        alt: {
          vi: "Bốn hình thức quy trình ký — tuần tự, song song, cá nhân, tùy chỉnh",
          en: "Four signing workflows — sequential, parallel, individual, custom",
        },
        file: "tao-tai-lieu-quy-trinh-ky.png",
        caption: {
          vi: "Ảnh bước 4 — chọn quy trình ký (bổ sung sau)",
          en: "Step 4 image — choose a signing workflow (to be added)",
        },
      },
      {
        label: { vi: "Bước 5", en: "Step 5" },
        body: {
          vi: "Sau khi chọn quy trình ký, người dùng có thể chọn **Thêm người tham gia** để thêm mới một người tham gia và chỉnh sửa thông tin người tham gia.",
          en: "After choosing a signing workflow, click **Add participant** to add a participant and edit their details.",
        },
        alt: {
          vi: "Thêm người tham gia và chỉnh sửa thông tin người tham gia",
          en: "Add a participant and edit participant details",
        },
        file: "tao-tai-lieu-nguoi-tham-gia.png",
        caption: {
          vi: "Ảnh bước 5 — thêm người tham gia (bổ sung sau)",
          en: "Step 5 image — add participants (to be added)",
        },
      },
      {
        label: { vi: "Bước 6", en: "Step 6" },
        body: {
          vi: "Cấu hình các **Thiết lập tùy chọn tài liệu** nếu có:",
          en: "Configure optional document settings if needed:",
        },
        items: {
          vi: [
            "**Danh mục:** Giúp phân loại tài liệu (giúp việc tra cứu, lọc và quản lý sau này thuận tiện hơn).",
            "**Đặt thời hạn ký:** Chọn mốc thời gian tối đa để các bên hoàn thành ký. Quá thời hạn này, tài liệu sẽ tự động hết hạn và không thể tiếp tục ký.",
          ],
          en: [
            "**Category:** classify the document for easier search and management later.",
            "**Set signing deadline:** the deadline for all parties to finish signing. After this, the document expires and can no longer be signed.",
          ],
        },
        alt: {
          vi: "Thiết lập danh mục và thời hạn ký của tài liệu",
          en: "Set the document category and signing deadline",
        },
        file: "tao-tai-lieu-tuy-chon.png",
        caption: {
          vi: "Ảnh bước 6 — thiết lập tùy chọn (bổ sung sau)",
          en: "Step 6 image — document options (to be added)",
        },
      },
      {
        label: { vi: "Bước 7", en: "Step 7" },
        body: {
          vi: "Chọn **Tiếp tục chỉnh sửa** để soạn thảo hợp đồng tài liệu.",
          en: "Click **Continue editing** to draft the contract document.",
        },
        alt: {
          vi: "Nút Tiếp tục chỉnh sửa để soạn thảo hợp đồng",
          en: "Continue editing button to draft the contract",
        },
        file: "tao-tai-lieu-tiep-tuc-chinh-sua.png",
        caption: {
          vi: "Ảnh bước 7 — tiếp tục chỉnh sửa (bổ sung sau)",
          en: "Step 7 image — continue editing (to be added)",
        },
      },
    ],
    draftSteps: [
      {
        label: { vi: "Bước 1", en: "Step 1" },
        body: {
          vi: "Tại mục **Người tham gia**, chọn người tham gia cần được thêm trường dữ liệu.",
          en: "Under **Participants**, select the participant who needs data fields added.",
        },
        alt: {
          vi: "Chọn người tham gia để thêm trường dữ liệu",
          en: "Select a participant to add data fields",
        },
        file: "soan-thao-nguoi-tham-gia.png",
        caption: {
          vi: "Placeholder — soan-thao-nguoi-tham-gia.png",
          en: "Placeholder — soan-thao-nguoi-tham-gia.png",
        },
      },
      {
        label: { vi: "Bước 2", en: "Step 2" },
        body: {
          vi: "Tại tệp tài liệu, người dùng chọn **chuột phải** tại vị trí cần thêm trường dữ liệu và thêm trường cần thiết.",
          en: "On the document file, right-click where you want to add a data field and add the required field.",
        },
        alt: {
          vi: "Chuột phải trên tài liệu để thêm trường dữ liệu",
          en: "Right-click the document to add a data field",
        },
        file: "soan-thao-them-truong.png",
        caption: {
          vi: "Ảnh bước 2 — thêm trường dữ liệu (bổ sung sau)",
          en: "Step 2 image — add data fields (to be added)",
        },
      },
      {
        label: { vi: "Bước 3", en: "Step 3" },
        body: {
          vi: "Sau khi đã thêm các trường cần thiết, chọn **Chia sẻ ngay** để gửi hợp đồng đến người tham gia để hoàn tất quy trình soạn thảo tài liệu.",
          en: "After adding the required fields, click **Share now** to send the contract to participants and complete drafting.",
        },
        alt: { vi: "Chia sẻ ngay", en: "Share now" },
        file: "soan-thao-chia-se-ngay.png",
        caption: {
          vi: "Ảnh bước 3 — chia sẻ hợp đồng",
          en: "Step 3 image — share the contract",
        },
      },
    ],
  },
};

export default guideCopy;
